import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'flag'
})
export class FlagPipe implements PipeTransform {

  transform(code: string): any {
    const flags: any = {
      en: '🇬🇧',
      ru: '🇷🇺',
      fr: '🇫🇷',
      pt: '🇵🇹',
      it: '🇮🇹',
      sp: '🇪🇸',
      de: '🇩🇪'
    };

    return flags[code] || ''
  }

}
